import { css } from '@emotion/react';
import { AGES_PER_GAME } from '@mythos/game/GameConstants';
import { GameViewModel } from '@mythos/game/GameViewModel';
import { getPhaseName } from '@mythos/game/Phases';
import { ageString } from '@mythos/game/Utility';
import { PhaseToBackgroundColor, UIColorPalette } from '../ColorPalette';
import GameTimeView from '../GameTimeView';
import { PhaseToSymbol } from '../Symbols';
import { MSymbolPrefix } from './MUIComponents';

export default function MGameStateView(props: { game: GameViewModel }) {
  const { game } = props;

  const backgroundColor = PhaseToBackgroundColor[game.phase];

  if (game.gameEndTimestamp) {
    return (
      <div
        css={MGameStateViewStyles.container}
        style={{
          backgroundColor,
        }}
      >
        <div>Game Over!</div>
        <GameTimeView
          extraSplitTime={game.gameEndTimestamp - game.gameStartTimestamp!}
        />
      </div>
    );
  }
  return (
    <div
      css={MGameStateViewStyles.container}
      style={{
        backgroundColor,
      }}
    >
      <MSymbolPrefix
        symbol={PhaseToSymbol[game.phase]}
        symbolCss={MGameStateViewStyles.symbol}
      >
        {getPhaseName(game.phase)}
      </MSymbolPrefix>
      <div>
        Turn {game.turn}/{game.turnsPerAge}
      </div>
      <div>
        Age {ageString(game.age)}/{ageString(AGES_PER_GAME)}
      </div>
      <GameTimeView
        splitStartTimestamp={
          game.gameEndTimestamp ? undefined : game.gameStartTimestamp!
        }
        extraSplitTime={
          game.gameEndTimestamp
            ? game.gameEndTimestamp - game.gameStartTimestamp!
            : undefined
        }
      />
    </div>
  );
}

const MGameStateViewStyles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: 5,

    color: UIColorPalette.gameStateText,
  }),
  symbol: css({
    height: 20,
  }),
};
